import React from 'react';
import Linker from '../../linker/Linker'
import * as path from '../../../../route/PathConfig'

import './InsightMain.css';

const InsightPageMain = (props) => {

  return (
    <>
      <div className="InsightTitle">
        <span className="blue">{props.insightData.title}</span>
        <div id="InsightSearchBtn">
          <Linker path={`${path.INSIGHT}`}>
            <a className="button darkGray" style={{marginTop: "0px"}}>목록</a>
          </Linker>
          {/* <a className="button darkGray" onClick={()=>props.handleDeleteBtn(props.noticeData.noticeID)} style={{marginTop: "0px"}}>삭제</a> */}
        </div>
      </div>
      <div style={{maginTop: "20px"}} dangerouslySetInnerHTML={{__html: props.insightData.content}}></div>
    </>
  )
}

export default InsightPageMain;